import client from './SharedConfig';

export const getJobsList = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/job/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const getJobDetails = (id = "0") => {
    const config = {
        method: 'GET',
        url: `advertisement/job/detail/${id}/`
    };
    return client.request(config)
};

export const deleteJob = ({header={}} = {}, id=0) => {
    const config = {
        method: 'DELETE',
        url: `advertisement/dashboard/job/delete/${id}/`,
        headers: header
    };
    return client.request(config)
};

export const addJobToFavourites = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/job/favourite/add/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const removeJobFromFavourites = ({header={}} = {}, id=0) => {
    const config = {
        method: 'POST',
        url: `advertisement/job/favourite/delete/${id}/`,
        headers: header
    };
    return client.request(config )
};

export const elevateJob = ({header={}} = {}, id=0) => {
    const config = {
        method: 'POST',
        url: `advertisement/dashboard/job/elevate/${id}/`,
        headers: header
    };
    return client.request(config )
};

export const reportJobAd = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/job/report/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const createJobAd = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/dashboard/job/create/',
        data: body,
        headers: header
    };
    return client.request(config )
};